// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Index_cardContainer__gYNx2","cardWrapper":"Index_cardWrapper__6xv3w","imgCard":"Index_imgCard__Y94JE"};